import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { UsuarioService } from '../services/usuario.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-esqueci-senha',
  templateUrl: './esqueci-senha.component.html',
  styleUrls: ['./esqueci-senha.component.css']
})
export class EsqueciSenhaComponent implements OnInit {
  public formSenha: FormGroup;
	public submitting = false;
  public error = false;

  constructor(
    private usuarioSvc: UsuarioService,
    private fb: FormBuilder,
    private router: Router

  ) { }

  ngOnInit() {
    this.criaForm();
    }

  criaForm() {
		this.formSenha = this.fb.group({
			email: [null, Validators.required, ]
		});
	}

	enviaEmail() {
    this.submitting = true;
    if(this.formSenha.valid){
      let toSend = this.formSenha.value;
      this.usuarioSvc.esqueciSenha(toSend).then((data: any) => {
        switch (data){
          case 'email':
            this.submitting = false;
            Swal.fire({
              type:'success',
              title: 'E-mail enviado!',
              text: 'Um e-mail para a troca de senha foi enviado, verifique sua caixa de mensagens.',
              onClose: () => {
                this.router.navigate(['login']);
              }
            });
            break;
          default:
            this.submitting = false;
            Swal.fire({
              type:'error',
              title: 'Ops! Algo de errado aconteceu!',
              text: 'Tente novamente mais tarde.'
            });
            break;
        }
  
      }).catch(err => {
        this.submitting = false;
        Swal.fire({
          type:'error',
          title: 'Ops! Algo de errado aconteceu!',
          text: 'Tente novamente mais tarde.'
        });
      });
    }
    else{
      this.submitting = false;
      Swal.fire({
        type:'error',
        title: 'E-mail inválido!',
        text: 'Tente novamente mais tarde.'
      });
    }
  }
}
